<template>
  <div>
    <!-- new 新轮播图banner -->
    <div class="swiper swiper-container link-swiper" v-if="isShowSwiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in linkEntrySwiper"
          :key="index"
        >
          <a
            href="javascript:;"
            class="link-entry"
            @click="jumpToLinkPage(item.link)"
          >
            <img :src="item.img[lang] || item.img.default" class="slide-img" />
          </a>
        </div>
      </div>
      <div class="swiper-pagination link-pagination"></div>
    </div>
    <!-- new 新轮播图banner -->
    <a
      href="javascript:;"
      class="link-entry"
      @click="jumpToLinkPage(isGlobalLink)"
      v-else-if="isGlobalLink"
    >
      <img :src="imgSrc" class="link-entry-img" alt="link-img" />
    </a>
    <div class="jp-link-entry" v-else>
      <a
        href="javascript:;"
        class="left-link-entry"
        v-show="isJpLeftLink"
        @click="jumpToLinkPage(leftLink)"
      >
        <img
          :src="leftImgSrc"
          class="left-link-entry-img"
          alt="left-link-img"
        />
      </a>
      <a
        href="javascript:;"
        class="right-link-entry"
        v-show="isJpRightLink"
        @click="jumpToLinkPage(rightLink)"
      >
        <img
          :src="rightImgSrc"
          class="right-link-entry-img"
          alt="right-link-img"
        />
      </a>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import { mapGetters, mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import openActivity, { BANNER_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      lang: state => state.lang
    }),
    ...mapGetters(['gameInfoConfig']),
    leftLink() {
      return this.gameInfoConfig?.linkEntry?.leftLink;
    },
    rightLink() {
      return this.gameInfoConfig?.linkEntry?.rightLink;
    },
    imgSrc() {
      let imgConfig = this.gameInfoConfig?.linkEntry?.img;
      return `${
        imgConfig[this.lang] ? imgConfig[this.lang] : imgConfig.default
      }`;
    },
    leftImgSrc() {
      let imgConfig = this.gameInfoConfig?.linkEntry?.leftImg;
      return `${
        imgConfig[this.lang] ? imgConfig[this.lang] : imgConfig.default
      }`;
    },
    rightImgSrc() {
      let imgConfig = this.gameInfoConfig?.linkEntry?.rightImg;
      return `${
        imgConfig[this.lang] ? imgConfig[this.lang] : imgConfig.default
      }`;
    },
    isGlobalLink() {
      if (+this.gameId === 191 && this.lang === 'zh-TW') {
        return `//auto-page.${globalConfig.getMainHost()}/pns906/`;
      }
      if (+this.gameId === 191 && this.lang === 'ja-JP') {
        return `//auto-page.${globalConfig.getMainHost()}/pnsline/`;
      }
      return this.gameInfoConfig?.linkEntry?.link;
    },
    isJpLeftLink() {
      if (this.gameId == 263 && this.lang == 'ja-JP') {
        return '';
      }
      return this.gameInfoConfig?.linkEntry?.leftLink;
    },
    isJpRightLink() {
      if (this.gameId == 263 && this.lang == 'ja-JP') {
        return '';
      }
      return this.gameInfoConfig?.linkEntry?.rightLink;
    },
    linkEntrySwiper() {
      return this.gameInfoConfig?.linkEntrySwiper;
    },
    isShowSwiper() {
      return this.linkEntrySwiper?.length > 0;
    }
  },
  methods: {
    initSwiper() {
      try {
        new Swiper('.link-swiper', {
          loop: true,
          direction: 'horizontal',
          pagination: {
            el: '.link-pagination'
          },
          effect: 'slide',
          observer: true,
          observeParents: true
        });
      } catch (e) {
        console.log(e);
      }
    },
    jumpToLinkPage(link) {
      openActivity(BANNER_ACTIVITY, link, {
        language: this.lang,
        appLanguage: this.lang,
        ...getGlobalGetLinkParams()
      });
    }
  },
  mounted() {
    if (this.isShowSwiper) {
      this.$nextTick(() => {
        this.initSwiper();
      });
    }
  }
};
</script>

<style scoped lang="scss">
.link-entry {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 0 24px;
  margin-top: 20px;
  &-img {
    width: 100%;
  }
}
.jp-link-entry {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 0 24px;
  margin-top: -25px;
  margin-bottom: 140px;

  .left-link-entry {
    &-img {
      width: 100%;
    }
  }
  .right-link-entry {
    &-img {
      width: 100%;
    }
  }
}

.slide-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (orientation: landscape) {
  .link-entry {
    padding: 0;
  }
  .slide-img {
    height: 219px;
  }
  .jp-link-entry {
    padding: 0;
    margin-top: -40px;
    margin-bottom: 152px;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-link-entry {
      cursor: pointer;
    }
    .right-link-entry {
      margin-left: 0px;
      cursor: pointer;
    }
  }
}
</style>
